import React from "react";
import { _post } from "../Api";
import { toast } from "react-toastify";
import EditTextField from "../components/EditArticle/EditTextField";
import cloudStore from "../store/CloudStore";
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const getGastrofixMerchant = (merchantId) => {
  let data = [{ merchantId: merchantId }];
  return _post("/nova/v2/gastrofix_merchants/index", data)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject(e);
    });
};

export function updateGastrofixMerchants(merchantIds, gastrofixMerchants, newData, oldValues, updatedKey = true) {
  let data = [];
  for (let i in merchantIds) {
    data.push({
      merchantId: merchantIds[i],
      ...newData[i],
    });
  }
  return _post("/nova/v2/gastrofix_merchants/update", data)
    .then((res) => {
      let newGastrofixMerchants = [...gastrofixMerchants];
      newGastrofixMerchants.forEach((gastrofixMerchant, index) => {
        newGastrofixMerchants[index] = { ...gastrofixMerchant };
        Object.keys(newData[index]).forEach((key) => {
          newGastrofixMerchants[index][key] = res.data[index][key];
        });
        if (updatedKey) {
          newGastrofixMerchants[index].updatedAt = new Date().toLocaleString();
        }
      });
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(newGastrofixMerchants);
    })
    .catch((e) => {
      let newGastrofixMerchants = [...gastrofixMerchants];
      gastrofixMerchants.forEach((gastrofixMerchant, index) => {
        newGastrofixMerchants[index] = { ...gastrofixMerchant };
        Object.keys(newData[index]).forEach((key) => {
          newGastrofixMerchants[index][key] = oldValues[index][key];
        });
        newGastrofixMerchants[gastrofixMerchant.id].updatedAt = new Date().toLocaleString();
      });
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject(newGastrofixMerchants);
    });
}

const useStyles = makeStyles(() => ({
  div: {
    margin: 8,
    maxWidth: 400,
  },
}));

function GastrofixApi3Setup(props) {
  const classes = useStyles();
  const [gastrofixMerchant, setGastrofixMerchant] = React.useState(null);

  const textFields = [
    { key: "ext_gastrofix_id", label: "Gastrofix Business Unit Id" },
    { key: "article_api_version", label: "Api Version 2 or 3" },
    { key: "token", label: "Api token" },
    { key: "waiter_id", label: "Waiter ID" },
    { key: "menu_sync_time", label: "Menu Sync Time in seconds" },
  ];

  const infoFields = [
    { key: "delivery_plu", label: "Delivery PLU" },
    { key: "payment_plu", label: "Payment PLU" },
  ];

  const paymentMethodsFields = [
    { key: "CASH", label: "CASH" },
    { key: "CARD", label: "CARD" },
    { key: "IDEAL", label: "IDEAL" },
  ];

  if (gastrofixMerchant == null) {
    getGastrofixMerchant(cloudStore.merchant.id).then((gastrofixMerchants) => {
      setGastrofixMerchant(gastrofixMerchants[0]);
    });
  }

  if (gastrofixMerchant == null) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <div>
      {textFields.map((textField) => {
        return (
          <div className={classes.div}>
            <EditTextField
              value={gastrofixMerchant[textField.key] == null ? "" : gastrofixMerchant[textField.key]}
              label={textField.label}
              onBlur={(value) => {
                updateGastrofixMerchants(
                  [cloudStore.merchant.id],
                  [gastrofixMerchant],
                  [{ [textField.key]: value }],
                  [{ [textField.key]: [gastrofixMerchant[textField.key]] }]
                )
                  .then((gastrofixMerchants) => {
                    setGastrofixMerchant(gastrofixMerchants[0]);
                  })
                  .catch((gastrofixMerchants) => {
                    setGastrofixMerchant(gastrofixMerchants[0]);
                  });
              }}
            />
          </div>
        );
      })}

      {infoFields.map((infoField) => {
        let info = JSON.parse(gastrofixMerchant.info);
        let field = "";
        if (info && info[infoField.key]) {
          field = info[infoField.key];
        }
        return (
          <div className={classes.div} key={infoField.key + "-" + gastrofixMerchant.updatedAt}>
            <EditTextField
              value={field}
              label={infoField.label}
              onBlur={(value) => {
                updateGastrofixMerchants(
                  [cloudStore.merchant.id],
                  [gastrofixMerchant],
                  [{ info: { [infoField.key]: parseInt(value) } }],
                  [{ info: { [infoField.key]: parseInt(field) } }]
                )
                  .then((gastrofixMerchants) => {
                    setGastrofixMerchant(gastrofixMerchants[0]);
                  })
                  .catch((gastrofixMerchants) => {
                    setGastrofixMerchant(gastrofixMerchants[0]);
                  });
              }}
            />
          </div>
        );
      })}

      {paymentMethodsFields.map((paymentMethodField) => {
        let info = JSON.parse(gastrofixMerchant.info);
        let field = "";
        if (info && info["payment_methods"] && info["payment_methods"][paymentMethodField.key]) {
          field = info["payment_methods"][paymentMethodField.key];
        }
        return (
          <div className={classes.div} key={paymentMethodField.key + "-" + gastrofixMerchant.updatedAt}>
            <EditTextField
              value={field}
              label={paymentMethodField.label}
              onBlur={(value) => {
                updateGastrofixMerchants(
                  [cloudStore.merchant.id],
                  [gastrofixMerchant],
                  [{ info: { payment_methods: { [paymentMethodField.key]: parseInt(value) } } }],
                  [{ info: { payment_methods: { [paymentMethodField.key]: parseInt(field) } } }]
                )
                  .then((gastrofixMerchants) => {
                    setGastrofixMerchant(gastrofixMerchants[0]);
                  })
                  .catch((gastrofixMerchants) => {
                    setGastrofixMerchant(gastrofixMerchants[0]);
                  });
              }}
            />
          </div>
        );
      })}
    </div>
  );
}

export default GastrofixApi3Setup;
